import React, { ComponentProps } from 'react';
import { Table as CarbonTable } from '@carbon/react';

export type TableProps = ComponentProps<typeof CarbonTable>;

export const Table = ({ children, ...props }: TableProps) => (
  <CarbonTable {...props}>{children}</CarbonTable>
);

Table.displayName = 'Table';
